export default __webpack_public_path__ + "static/media/Setting.d48174e4.svg";